var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toSort"},[_c('v-touch',{staticClass:"fs-14",attrs:{"tag":"a"},on:{"tap":_vm._tap}},[_vm._v(_vm._s(_vm.propText))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/show/toSort.vue?vue&type=template&id=6b340526&scoped=true&
// module id = null
// module chunks = 